export * from './atoms';
export * from './organisms';
export * from './molecules';

import { BuildingAtoms } from './atoms';
import { BuildingMolecules } from './molecules';
import { BuildingOrganisms } from './organisms';


export const BuildingComponents = [
    ...BuildingAtoms,
    ...BuildingMolecules,
    ...BuildingOrganisms
]